import { PlayerResult } from '@shared/api-dto';
import React from 'react';
import { ScoresByPlayerGuid } from './room-data-helpers';

import './team-list.css';

export type TeamListProps = {
  scores: ScoresByPlayerGuid;
  team: PlayerResult[];
  // Colors the avatars for the team; defaults to the players' own team.
  teamNumber?: number;
};

export const TeamList = ({ scores, team, teamNumber }: TeamListProps) => {
  return (
    <ul className='teamList'>
      {team.map(p => {
        const score = scores[p.user.guid] ?? 0;
        const teamClass = `team${teamNumber ?? p.team ?? 1}`;
        return (
          <li key={p.user.guid} className='teamListItem'>
            <span className={`avatar ${teamClass}`}>{p.user.name.trim().charAt(0)}</span>
            <span className="teamListName">{p.user.name}</span>
            <span className="teamListScore">
              {score} pt{score === 1 ? '' : 's'}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
